import React, { memo, useEffect, useState } from "react"
import { css, Theme } from "@emotion/react"
import { extractNumber, formatCurrency } from "@ncs/ts-utils"
import { useCustomerPartsEcomm } from "@ncs/ncs-api"
import { Paragraph } from "./Paragraph"

export interface QuickOrderPriceProps {
	titleSize?: "big" | "small"
	price: number | string
	round?: boolean
	isLoading?: boolean
	partId: string
}

export const QuickOrderPrice: React.FC<QuickOrderPriceProps> = memo(
	({ isLoading, titleSize = "small", price, round, partId }) => {
		const [netPrice, setNetPrice] = useState(price)

		const { data: part } = useCustomerPartsEcomm({
			params: {
				onlinePartId: [partId],
			},
			queryConfig: {
				enabled: !!price,
			},
			pageSize: 999,
		})

		useEffect(() => {
			if (part && part.length > 0 && part[0].netPrice) {
				setNetPrice(part[0].netPrice)
			}
		}, [part])

		const fontSize = titleSize === "big" ? "1.8" : "1.25"

		return (
			<Paragraph
				css={(theme: Theme) => finalPriceStyle(theme, netPrice < price, fontSize)}
				bold
			>
				{formatCurrency(extractNumber(netPrice), round ? 0 : undefined)}
			</Paragraph>
		)
	}
)

const finalPriceStyle = (theme: Theme, hasOffer: boolean, fontSize: string) => css`
	color: ${hasOffer ? "#10A85F" : "#111827"};
	font-size: ${fontSize}rem;
`
